(function () {
  var _transforming = false;

  var CART_DRAWER_CSS = [
    ':host {',
    '  letter-spacing: 0.06rem;',
    '  font-weight: 600;',
    '}',
    'div[data-state="open"]:has(> [role="dialog"]) {',
    '  z-index: 2147483647 !important;',
    '}',
    '#cart-drawer header {',
    '  background-color: #fff !important;',
    '}',
    '#cart-drawer header > div {',
    '  padding-left: 24px !important;',
    '  padding-right: 24px !important;',
    '}',
    '@media (max-width: 749px) {',
    '  #cart-drawer header > div {',
    '    padding-left: 20px !important;',
    '    padding-right: 20px !important;',
    '  }',
    '}',
    '#cart-drawer header h2 {',
    '  font-size: 18px !important;',
    '  font-weight: 500 !important;',
    '  line-height: 23px !important;',
    '  color: #244545 !important;',
    '  font-family: studiofeixen, sans-serif !important;',
    '  display: flex !important;',
    '  align-items: center !important;',
    '  gap: 5px !important;',
    '  margin: 0 !important;',
    '}',
    '.rc-cart-count-badge {',
    '  display: inline-flex;',
    '  align-items: center;',
    '  justify-content: center;',
    '  width: 20px;',
    '  height: 20px;',
    '  min-width: 20px;',
    '  background-color: #244545;',
    '  color: #fff;',
    '  border-radius: 50%;',
    '  font-size: 12px;',
    '  font-weight: 600;',
    '  line-height: 1;',
    '  font-family: studiofeixen, sans-serif;',
    '  flex-shrink: 0;',
    '}',
    '#cart-drawer header button > svg {',
    '  width: 16px !important;',
    '  height: 16px !important;',
    '}',
    '#cart-drawer [role="listitem"] {',
    '  border-radius: 4px !important;',
    '  background-color: #fff !important;',
    '  border-bottom: none !important;',
    '  margin: 12px 24px !important;',
    '}',
    '#cart-drawer [role="listitem"] p.font-semibold {',
    '  font-size: 14px !important;',
    '  font-weight: 500 !important;',
    '  line-height: 19px !important;',
    '  letter-spacing: 0 !important;',
    '  color: #244545 !important;',
    '  font-family: studiofeixen, sans-serif !important;',
    '}',
    '#cart-drawer [role="listitem"] dl p {',
    '  font-size: 12px !important;',
    '  font-weight: 400 !important;',
    '  line-height: 15px !important;',
    '  letter-spacing: 0 !important;',
    '  color: #667D7D !important;',
    '  font-family: studiofeixen, sans-serif !important;',
    '}',
    '#cart-drawer [role="listitem"] [part="money"] {',
    '  font-size: 12px !important;',
    '  font-weight: 400 !important;',
    '  line-height: 17px !important;',
    '  letter-spacing: 0 !important;',
    '  color: #667d7d !important;',
    '  font-family: studiofeixen, sans-serif !important;',
    '}',
    '#cart-drawer [role="listitem"] [part~="discount"] {',
    '  font-size: 12px !important;',
    '  font-weight: 400 !important;',
    '  line-height: 17px !important;',
    '  letter-spacing: 0 !important;',
    '  color: #244545 !important;',
    '  font-family: studiofeixen, sans-serif !important;',
    '}',
    '#cart-drawer [role="listitem"] span[part="money"].line-through {',
    '  font-size: 11px !important;',
    '  margin-right: 0 !important;',
    '}',
    '#cart-drawer [role="listitem"] select {',
    '  border: 1px solid #e9ecec !important;',
    '  border-radius: 4px !important;',
    '  font-size: 12px !important;',
    '  font-weight: 400 !important;',
    '  line-height: 19px !important;',
    '  letter-spacing: 0 !important;',
    '  color: #244545 !important;',
    '  font-family: studiofeixen, sans-serif !important;',
    '}',
    '#cart-drawer [role="listitem"] div:has(> input[name="quantity"]) {',
    '  border: 1px solid #e9ecec !important;',
    '  border-radius: 4px !important;',
    '  width: 89px !important;',
    '  height: 34px !important;',
    '  padding: 0 8px !important;',
    '  gap: 4px !important;',
    '  flex-shrink: 0 !important;',
    '}',
    '#cart-drawer [role="listitem"] div:has(> input[name="quantity"]) button {',
    '  width: 20px !important;',
    '  height: 20px !important;',
    '  min-width: 20px !important;',
    '  padding: 0 !important;',
    '  flex-shrink: 0 !important;',
    '}',
    '#cart-drawer [role="listitem"] input[name="quantity"] {',
    '  font-size: 12px !important;',
    '  font-weight: 400 !important;',
    '  line-height: 19px !important;',
    '  letter-spacing: 0.6px !important;',
    '  color: #244545 !important;',
    '  font-family: studiofeixen, sans-serif !important;',
    '  padding: 0 !important;',
    '  width: auto !important;',
    '  flex: 1 !important;',
    '  min-width: 0 !important;',
    '}',
    '#cart-drawer [data-slot="carousel"] {',
    '  margin-left: 0 !important;',
    '  margin-right: 0 !important;',
    '}',
    '#cart-drawer div:has(> div > [data-slot="carousel"]) {',
    '  padding-right: 0 !important;',
    '}',
    '#cart-drawer [data-slot="carousel-previous"],',
    '#cart-drawer [data-slot="carousel-next"] {',
    '  width: 28px !important;',
    '  height: 28px !important;',
    '  min-width: 28px !important;',
    '  min-height: 28px !important;',
    '  background-color: rgba(255,255,255,0.85) !important;',
    '  color: #244545 !important;',
    '  border-radius: 50% !important;',
    '  top: 97px !important;',
    '  transform: translateY(0) !important;',
    '  box-shadow: 0 1px 4px rgba(0,0,0,0.10) !important;',
    '}',
    '#cart-drawer [data-slot="carousel-previous"] {',
    '  left: 31px !important;',
    '}',
    '#cart-drawer [data-slot="carousel-next"] {',
    '  right: 31px !important;',
    '}',
    '#cart-drawer [data-slot="carousel-previous"] svg,',
    '#cart-drawer [data-slot="carousel-next"] svg {',
    '  width: 14px !important;',
    '  height: 14px !important;',
    '}',
    '#cart-drawer [data-slot="carousel-previous"]:hover,',
    '#cart-drawer [data-slot="carousel-next"]:hover {',
    '  background-color: rgba(255,255,255,1) !important;',
    '}',
    '#cart-drawer [data-slot="carousel-previous"]:disabled,',
    '#cart-drawer [data-slot="carousel-next"]:disabled {',
    '  display: none !important;',
    '}',
    '#cart-drawer [data-slot="carousel-item"] {',
    '  flex-basis: calc(100% / 3) !important;',
    '  min-width: calc(100% / 3) !important;',
    '}',
    '#cart-drawer [data-slot="carousel-item"] > div {',
    '  flex-direction: column !important;',
    '  align-items: stretch !important;',
    '  padding: 0 !important;',
    '  border: 1px solid #e9ecec !important;',
    '  border-radius: 4px !important;',
    '  overflow: hidden !important;',
    '}',
    '#cart-drawer [data-slot="carousel-item"] img {',
    '  width: 100% !important;',
    '  height: auto !important;',
    '  aspect-ratio: 1 / 1 !important;',
    '  object-fit: cover !important;',
    '  border-radius: 0 !important;',
    '  margin-right: 0 !important;',
    '  flex-shrink: 0 !important;',
    '}',
    '#cart-drawer [data-slot="carousel-item"] > div > div {',
    '  padding: 8px 12px 12px !important;',
    '  width: 100% !important;',
    '  flex: 1 !important;',
    '  display: flex !important;',
    '  flex-direction: column !important;',
    '  gap: 8px !important;',
    '}',
    '#cart-drawer [data-slot="carousel-item"] > div > div > div {',
    '  flex-direction: column !important;',
    '  align-items: flex-start !important;',
    '  justify-content: space-between !important;',
    '  flex: 1 !important;',
    '  gap: 8px !important;',
    '}',
    '#cart-drawer [data-slot="carousel-item"] > div > div > div > div:last-child {',
    '  width: 100% !important;',
    '}',
    '#cart-drawer [data-slot="carousel-item"] .font-semibold {',
    '  font-size: 12px !important;',
    '  font-weight: 500 !important;',
    '  line-height: 17px !important;',
    '  min-height: 34px !important;',
    '  letter-spacing: 0 !important;',
    '  color: #244545 !important;',
    '  font-family: studiofeixen, sans-serif !important;',
    '}',
    '#cart-drawer [data-slot="carousel-item"] [part="money"] {',
    '  font-size: 12px !important;',
    '  font-weight: 400 !important;',
    '  line-height: 17px !important;',
    '  letter-spacing: 0 !important;',
    '  color: #667d7d !important;',
    '  font-family: studiofeixen, sans-serif !important;',
    '  text-align: left !important;',
    '  margin-top: 8px !important;',
    '  margin-bottom: 4px !important;',
    '}',
    '#cart-drawer [data-slot="carousel-item"] button[class~="bg-storefront-drawer-primary"] {',
    '  background-color: #244545 !important;',
    '  border-radius: 54px !important;',
    '  font-size: 12px !important;',
    '  font-weight: 500 !important;',
    '  line-height: 17px !important;',
    '  letter-spacing: 0 !important;',
    '  color: #fff !important;',
    '  font-family: studiofeixen, sans-serif !important;',
    '  width: 100% !important;',
    '  padding: 6px 12px !important;',
    '  display: flex !important;',
    '  justify-content: center !important;',
    '  align-items: center !important;',
    '}',
    '[role="dialog"] {',
    '  background-color: #fff !important;',
    '}',
    '[role="dialog"] img {',
    '  border-radius: 4px !important;',
    '}',
    '[role="dialog"] .font-semibold {',
    '  font-size: 14px !important;',
    '  font-weight: 500 !important;',
    '  line-height: 19px !important;',
    '  letter-spacing: 0 !important;',
    '  color: #244545 !important;',
    '  font-family: studiofeixen, sans-serif !important;',
    '}',
    '[role="dialog"] [part="money"] {',
    '  font-size: 12px !important;',
    '  font-weight: 400 !important;',
    '  line-height: 17px !important;',
    '  letter-spacing: 0 !important;',
    '  color: #244545 !important;',
    '  font-family: studiofeixen, sans-serif !important;',
    '  text-align: right !important;',
    '}',
    '[role="dialog"] label[for*="selling_plan"] {',
    '  display: none !important;',
    '}',
    '[role="dialog"] label[for^="variant"] {',
    '  font-size: 12px !important;',
    '  font-weight: 400 !important;',
    '  line-height: 15px !important;',
    '  letter-spacing: 0 !important;',
    '  color: #667d7d !important;',
    '  font-family: studiofeixen, sans-serif !important;',
    '  margin-bottom: 4px !important;',
    '  display: block !important;',
    '}',
    '[role="dialog"] div:has(> input[name="quantity"]) {',
    '  border: 1px solid #e9ecec !important;',
    '  border-radius: 4px !important;',
    '  width: 89px !important;',
    '  height: 34px !important;',
    '  padding: 0 8px !important;',
    '  gap: 4px !important;',
    '}',
    '[role="dialog"] div:has(> input[name="quantity"]) button {',
    '  width: 20px !important;',
    '  height: 20px !important;',
    '  min-width: 20px !important;',
    '  padding: 0 !important;',
    '  flex-shrink: 0 !important;',
    '}',
    '[role="dialog"] input[name="quantity"] {',
    '  font-size: 12px !important;',
    '  font-weight: 400 !important;',
    '  line-height: 19px !important;',
    '  letter-spacing: 0.6px !important;',
    '  color: #244545 !important;',
    '  font-family: studiofeixen, sans-serif !important;',
    '  padding: 0 !important;',
    '  width: auto !important;',
    '  flex: 1 !important;',
    '  min-width: 0 !important;',
    '}',
    '[role="dialog"] select[name="selling_plan"], [role="dialog"] select[name="variant"] {',
    '  border: 1px solid #e9ecec !important;',
    '  border-radius: 4px !important;',
    '  font-size: 12px !important;',
    '  font-weight: 400 !important;',
    '  line-height: 19px !important;',
    '  letter-spacing: 0 !important;',
    '  color: #244545 !important;',
    '  font-family: studiofeixen, sans-serif !important;',
    '}',
    '[role="dialog"] button[class~="bg-storefront-drawer-primary"] {',
    '  background-color: #244545 !important;',
    '  border-radius: 54px !important;',
    '  font-size: 16px !important;',
    '  font-weight: 500 !important;',
    '  line-height: 19px !important;',
    '  letter-spacing: 0.6px !important;',
    '  color: #fff !important;',
    '  font-family: studiofeixen, sans-serif !important;',
    '}',
    '#cart-drawer a[data-slot="button"][class~="bg-storefront-drawer-primary"] {',
    '  color: #fff !important;',
    '}',
    '#cart-drawer div:has([data-slot="carousel"]) .dynamic-richtext {',
    '  margin-bottom: 6px !important;',
    '}',
    '#cart-drawer div:has([data-slot="carousel"]) .dynamic-richtext p {',
    '  font-size: 12px !important;',
    '  font-weight: 400 !important;',
    '  line-height: 17px !important;',
    '  letter-spacing: 0 !important;',
    '  color: #667d7d !important;',
    '  font-family: studiofeixen, sans-serif !important;',
    '}',
    '#cart-drawer footer {',
    '  background-color: #fff !important;',
    '  display: flex !important;',
    '  flex-direction: column !important;',
    '  gap: 18px !important;',
    '  padding-left: 20px !important;',
    '  padding-right: 20px !important;',
    '}',
    '#cart-drawer footer > div {',
    '  padding-left: 0 !important;',
    '  padding-right: 0 !important;',
    '  padding-top: 0 !important;',
    '  padding-bottom: 0 !important;',
    '}',
    '#cart-drawer footer .dynamic-richtext p,',
    '#cart-drawer footer .dynamic-richtext strong {',
    '  font-size: 16px !important;',
    '  font-weight: 500 !important;',
    '  line-height: 19px !important;',
    '  letter-spacing: 0 !important;',
    '  color: #244545 !important;',
    '  font-family: studiofeixen, sans-serif !important;',
    '}',
    '#cart-drawer footer [part="money"] {',
    '  font-size: 16px !important;',
    '  font-weight: 500 !important;',
    '  line-height: 19px !important;',
    '  letter-spacing: 0 !important;',
    '  color: #667d7d !important;',
    '  font-family: studiofeixen, sans-serif !important;',
    '}',
    '#cart-drawer footer [part~="discount"] {',
    '  font-size: 16px !important;',
    '  font-weight: 500 !important;',
    '  line-height: 19px !important;',
    '  letter-spacing: 0 !important;',
    '  color: #244545 !important;',
    '  font-family: studiofeixen, sans-serif !important;',
    '}',
    '#cart-drawer footer button[class~="bg-storefront-drawer-primary"] {',
    '  background-color: #244545 !important;',
    '  border-radius: 54px !important;',
    '  font-size: 16px !important;',
    '  font-weight: 500 !important;',
    '  line-height: 19px !important;',
    '  letter-spacing: 0.6px !important;',
    '  text-transform: uppercase !important;',
    '  color: #fff !important;',
    '  font-family: studiofeixen, sans-serif !important;',
    '}',
    '#cart-drawer [role="listitem"] img {',
    '  border-radius: 4px !important;',
    '}',
    '#cart-drawer button[class*="bg-storefront-drawer-secondary"] {',
    '  border-radius: 4px !important;',
    '  font-size: 11px !important;',
    '  font-weight: 400 !important;',
    '  line-height: 19px !important;',
    '  letter-spacing: 0 !important;',
    '  color: #244545 !important;',
    '  font-family: studiofeixen, sans-serif !important;',
    '}',
    '#cart-drawer [role="listitem"] button[data-rc-trash] {',
    '  width: auto !important;',
    '  height: auto !important;',
    '  padding: 0 !important;',
    '  background: none !important;',
    '  border: none !important;',
    '  cursor: pointer !important;',
    '}',
    '@media (max-width: 474px) {',
    '  #cart-drawer [data-slot="carousel-item"] {',
    '    flex-basis: calc(100% / 2) !important;',
    '    min-width: calc(100% / 2) !important;',
    '  }',
    '  #cart-drawer button[class*="bg-storefront-drawer-secondary"] {',
    '    font-size: 10px !important;',
    '    line-height: 15px !important;',
    '  }',
    '}'
  ].join('\n');

  function injectStyles(shadowRoot) {
    if (shadowRoot.querySelector('#rc-cart-drawer-styles')) return;
    var style = document.createElement('style');
    style.id = 'rc-cart-drawer-styles';
    style.textContent = CART_DRAWER_CSS;
    shadowRoot.appendChild(style);
  }

  function transformCartCountBadge(shadowRoot) {
    if (_transforming) return;
    var h2 = shadowRoot.querySelector('#cart-drawer header h2');
    if (!h2) return;
    var text = h2.textContent;
    var match = text.match(/\((\d+)\)/);
    if (!match) return;
    _transforming = true;
    var count = match[1];
    var title = text.replace(/\s*\(\d+\)/, '').trim();
    h2.textContent = '';
    h2.appendChild(document.createTextNode(title));
    var badge = document.createElement('span');
    badge.className = 'rc-cart-count-badge';
    badge.textContent = count;
    h2.appendChild(badge);
    _transforming = false;
  }

  var SVG_MINUS = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M5.2251 10H14.7751" stroke="#244545" stroke-width="1.5" stroke-miterlimit="10"/></svg>';
  var SVG_PLUS  = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M5.2251 10H14.7751" stroke="#244545" stroke-width="1.5" stroke-miterlimit="10"/><path d="M10 5.2251V14.7751" stroke="#244545" stroke-width="1.5" stroke-miterlimit="10"/></svg>';

  function replaceQuantityIcons(shadowRoot) {
    var btns = shadowRoot.querySelectorAll('#cart-drawer [role="listitem"] button[data-slot="button"]:not([data-rc-icon]), [role="dialog"] button[data-slot="button"]:not([data-rc-icon])');
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      var isMinus = !!btn.querySelector('.lucide-circle-minus');
      var isPlus  = !!btn.querySelector('.lucide-circle-plus');
      if (!isMinus && !isPlus) continue;
      btn.setAttribute('data-rc-icon', isMinus ? 'minus' : 'plus');
      var oldSvg = btn.querySelector('svg');
      if (!oldSvg) continue;
      var div = document.createElement('div');
      div.innerHTML = isMinus ? SVG_MINUS : SVG_PLUS;
      var newSvg = div.firstChild;
      oldSvg.parentNode.replaceChild(newSvg, oldSvg);
    }
  }

  function styleFooter(shadowRoot) {
    var footer = shadowRoot.querySelector('#cart-drawer footer');
    if (!footer) return;
    footer.style.setProperty('padding-top', '24px', 'important');
    footer.style.setProperty('padding-bottom', '24px', 'important');
    var innerDivs = footer.querySelectorAll(':scope > div');
    for (var i = 0; i < innerDivs.length; i++) {
      innerDivs[i].style.setProperty('padding-top', '0', 'important');
      innerDivs[i].style.setProperty('padding-bottom', '0', 'important');
    }
  }

  function styleListItems(shadowRoot) {
    var items = shadowRoot.querySelectorAll('#cart-drawer [role="listitem"]');
    for (var i = 0; i < items.length; i++) {
      items[i].style.setProperty('padding', '8px', 'important');
    }
  }

  function fixCarouselAlignment(shadowRoot) {
    var carousel = shadowRoot.querySelector('#cart-drawer [data-slot="carousel"]');
    if (!carousel || carousel._rcAlignFixed) return;

    var content = carousel.querySelector('[data-slot="carousel-content"]');
    if (!content) return;

    var tries = 0;
    function attempt() {
      if (++tries > 60) return;
      var scrollEl = content.firstElementChild;
      if (!scrollEl) { requestAnimationFrame(attempt); return; }

      var tx = Math.round(new DOMMatrix(window.getComputedStyle(scrollEl).transform).m41);
      if (tx <= 0) { requestAnimationFrame(attempt); return; }

      carousel._rcAlignFixed = true;
      carousel.style.setProperty('overflow', 'hidden', 'important');
      content.style.setProperty('overflow', 'visible', 'important');
      content.style.setProperty('transform', 'translateX(' + (-tx) + 'px)', 'important');
    }

    requestAnimationFrame(attempt);
  }

  function styleQuantityRow(shadowRoot) {
    var items = shadowRoot.querySelectorAll('#cart-drawer [role="listitem"]');
    items.forEach(function(item) {
      var children = Array.from(item.children);

      var imageRow = children.find(function(c) { return !!c.querySelector('img'); });
      var companionWrapper = children.find(function(c) {
        return !!(c.querySelector('select[name="selling_plan"]') ||
                  c.querySelector('button[class*="bg-storefront-drawer-secondary"]'));
      });

      if (!imageRow || !companionWrapper) return;

      if (!companionWrapper.querySelector('div:has(> input[name="quantity"])')) {
        var qsEl = imageRow.querySelector('div:has(> input[name="quantity"])');
        if (qsEl) companionWrapper.insertBefore(qsEl, companionWrapper.firstChild);
      }

      companionWrapper.style.setProperty('display', 'flex', 'important');
      companionWrapper.style.setProperty('flex-direction', 'row', 'important');
      companionWrapper.style.setProperty('align-items', 'center', 'important');
      companionWrapper.style.setProperty('gap', '8px', 'important');

      var fsEl = companionWrapper.querySelector('div:has(select[name="selling_plan"])');
      var subBtn = companionWrapper.querySelector('button[class*="bg-storefront-drawer-secondary"]');

      if (fsEl) {
        fsEl.style.setProperty('flex', '1', 'important');
        fsEl.style.setProperty('width', 'auto', 'important');
        fsEl.style.setProperty('min-width', '0', 'important');
        var label = fsEl.querySelector('label');
        if (label) label.style.setProperty('display', 'none', 'important');
      }
      if (subBtn) {
        subBtn.style.setProperty('flex', '1', 'important');
        subBtn.style.setProperty('width', 'auto', 'important');
        subBtn.style.setProperty('min-width', '0', 'important');
      }
    });
  }

  var CUSTOM_TRASH_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.51842 6.89062H14.4817V7.45312C14.4817 7.65478 14.4825 7.85967 14.4833 8.06693C14.4907 9.90288 14.4988 11.9246 13.9434 13.5265C13.6264 14.4409 13.1152 15.2589 12.2902 15.8425C11.4665 16.4251 10.3859 16.7344 9.00139 16.7344C7.61689 16.7344 6.53618 16.4251 5.71222 15.8425C4.88705 15.2591 4.37548 14.4411 4.05812 13.5267C3.50158 11.9233 3.50956 9.89959 3.51681 8.06225C3.51762 7.85659 3.51842 7.65327 3.51842 7.45312V6.89062ZM4.64238 8.01562C4.64235 8.02563 4.64232 8.03564 4.6423 8.04564C4.63693 9.92929 4.63175 11.7485 5.12092 13.1578C5.38313 13.9133 5.7764 14.5101 6.36173 14.924C6.94827 15.3387 7.78371 15.6094 9.00139 15.6094C10.2191 15.6094 11.0543 15.3387 11.6405 14.924C12.2256 14.5102 12.6185 13.9135 12.8804 13.158C13.3686 11.7501 13.3633 9.93315 13.3578 8.05142C13.3578 8.03949 13.3577 8.02756 13.3577 8.01562H4.64238Z" fill="#244545"/><path fill-rule="evenodd" clip-rule="evenodd" d="M7.73498 4.47002C7.73525 4.52503 7.73553 4.58177 7.73553 4.64062H6.61053C6.61053 4.59559 6.61026 4.54822 6.60998 4.49906C6.60877 4.28401 6.60737 4.03482 6.62729 3.79781C6.65226 3.50084 6.71349 3.16591 6.88112 2.85434C7.25248 2.16407 7.99873 1.82812 9.14122 1.82812C10.2837 1.82812 11.0298 2.16408 11.4009 2.85458C11.5684 3.16618 11.6294 3.50112 11.6543 3.79803C11.674 4.03452 11.6726 4.28327 11.6714 4.49799C11.6711 4.54754 11.6708 4.59527 11.6708 4.64062H10.5458C10.5458 4.58119 10.5461 4.52393 10.5464 4.46842C10.5474 4.25827 10.5484 4.0734 10.5332 3.89184C10.5145 3.66818 10.474 3.50641 10.4099 3.38711C10.3179 3.2158 10.0805 2.95312 9.14122 2.95312C8.20198 2.95312 7.96413 3.2158 7.87183 3.38735C7.80763 3.50669 7.76714 3.66846 7.74834 3.89206C7.73304 4.07396 7.73395 4.2593 7.73498 4.47002Z" fill="#244545"/><path fill-rule="evenodd" clip-rule="evenodd" d="M14.4844 6.32812H3.51562V5.20312H14.4844V6.32812Z" fill="#244545"/></svg>';

  function styleCartItemDetails(shadowRoot) {
    var items = shadowRoot.querySelectorAll('#cart-drawer [role="listitem"]');
    items.forEach(function(item) {
      var children = Array.from(item.children);
      var imageRow = children.find(function(c) { return !!c.querySelector('img'); });
      if (!imageRow) return;

      var trashBtn = item.querySelector('button[data-rc-trash]') ||
                     item.querySelector('button:has(svg.lucide-trash2)');
      var priceArea = imageRow.querySelector('.text-right.whitespace-nowrap');

      if (trashBtn) {
        if (trashBtn.querySelector('svg.lucide-trash2')) {
          var srText = (trashBtn.querySelector('.sr-only') || {}).textContent || 'Remove';
          trashBtn.innerHTML = CUSTOM_TRASH_SVG + '<span class="sr-only">' + srText + '</span>';
          trashBtn.setAttribute('data-rc-trash', '1');
        }
        if (priceArea && trashBtn.parentElement !== priceArea) {
          priceArea.style.setProperty('display', 'flex', 'important');
          priceArea.style.setProperty('flex-direction', 'column', 'important');
          priceArea.style.setProperty('align-items', 'flex-end', 'important');
          priceArea.style.setProperty('gap', '4px', 'important');
          priceArea.appendChild(trashBtn);
        }
      }

      if (priceArea) {
        var moneySpans = Array.from(priceArea.querySelectorAll('span[part*="money"]'));
        if (moneySpans.length >= 2) {
          var priceRow = priceArea.querySelector('[data-rc-price-row]');
          var needsWrap = !priceRow || !moneySpans.every(function(s) { return s.parentElement === priceRow; });
          if (needsWrap) {
            if (!priceRow) {
              priceRow = document.createElement('div');
              priceRow.setAttribute('data-rc-price-row', '1');
              priceArea.insertBefore(priceRow, priceArea.firstChild);
            }
            moneySpans.forEach(function(s) { priceRow.appendChild(s); });
          }
          priceRow.style.setProperty('display', 'flex', 'important');
          priceRow.style.setProperty('flex-direction', window.innerWidth < 500 ? 'column' : 'row', 'important');
          priceRow.style.setProperty('align-items', window.innerWidth < 500 ? 'flex-end' : 'center', 'important');
          priceRow.style.setProperty('gap', window.innerWidth < 500 ? '0' : '7px', 'important');
          priceRow.style.setProperty('justify-content', 'flex-end', 'important');
        }
      }

      var savingsEl = item.querySelector('[data-rc-savings]') ||
                      imageRow.querySelector('div.text-xs.text-storefront-drawer-accent');
      if (savingsEl && savingsEl.textContent.trim()) {
        if (!savingsEl.getAttribute('data-rc-savings')) {
          savingsEl.setAttribute('data-rc-savings', '1');
        }
        var isSubscription = !item.querySelector('button[class*="bg-storefront-drawer-secondary"]');
        if (!isSubscription) {
          savingsEl.style.setProperty('display', 'none', 'important');
        } else {
          savingsEl.childNodes.forEach(function(node) {
            if (node.nodeType === 3) {
              node.textContent = node.textContent.replace(/(\d+[.,]\d+)%/, function(_, n) {
                return Math.round(parseFloat(n.replace(',', '.'))) + '%';
              });
            }
          });
          var namePara = imageRow.querySelector('p.font-semibold');
          if (namePara && savingsEl.parentElement !== namePara.parentElement) {
            var nameCol = namePara.parentElement;
            var dl = nameCol.querySelector('dl');
            var anchor = dl || namePara;
            nameCol.insertBefore(savingsEl, anchor.nextElementSibling);
          }
          savingsEl.style.setProperty('display', 'block', 'important');
          savingsEl.style.setProperty('width', 'fit-content', 'important');
          savingsEl.style.setProperty('align-self', 'flex-start', 'important');
          savingsEl.style.setProperty('background-color', '#F7F4E9', 'important');
          savingsEl.style.setProperty('padding', '2px 4px', 'important');
          savingsEl.style.setProperty('border-radius', '2px', 'important');
          savingsEl.style.setProperty('color', '#667D7D', 'important');
          savingsEl.style.setProperty('font-size', window.innerWidth < 500 ? '10px' : '12px', 'important');
          savingsEl.style.setProperty('font-weight', '400', 'important');
          savingsEl.style.setProperty('line-height', '16px', 'important');
          savingsEl.style.setProperty('text-align', 'left', 'important');
          savingsEl.style.setProperty('font-family', 'studiofeixen, sans-serif', 'important');
          savingsEl.style.setProperty('margin-top', '4px', 'important');
        }
      }
    });
  }

  function updateCarouselSubPriceLabel(shadowRoot) {
    var items = shadowRoot.querySelectorAll('#cart-drawer [data-slot="carousel-item"]');
    items.forEach(function(item) {
      if (item._rcSubPriceDone) return;

      var priceEl = item.querySelector('[part="money"]');
      if (!priceEl) return;

      var titleEl = item.querySelector('.font-semibold');
      if (!titleEl) return;
      var productTitle = titleEl.textContent.trim();
      if (!productTitle) return;

      item._rcSubPriceDone = true;
      priceEl.style.setProperty('display', 'none', 'important');

      fetch('/search/suggest.json?q=' + encodeURIComponent(productTitle) + '&resources[type]=product&resources[limit]=1')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var products = data.resources && data.resources.results && data.resources.results.products;
          if (!products || !products.length) throw new Error('no results');
          var productUrl = products[0].url;
          if (!item.querySelector('[data-rc-title-link]')) {
            var a = document.createElement('a');
            a.setAttribute('data-rc-title-link', '1');
            a.href = productUrl;
            a.style.setProperty('color', 'inherit', 'important');
            a.style.setProperty('text-decoration', 'none', 'important');
            a.style.setProperty('cursor', 'pointer', 'important');
            titleEl.parentNode.insertBefore(a, titleEl);
            a.appendChild(titleEl);
          }
          var urlMatch = productUrl && productUrl.match(/\/products\/([^/?#]+)/);
          if (!urlMatch) throw new Error('no handle');
          return fetch('/products/' + urlMatch[1] + '.js').then(function(r) { return r.json(); });
        })
        .then(function(product) {
          var plans = product.selling_plan_groups;
          if (!plans || !plans.length) return;

          var discountPct = 0;
          plans.forEach(function(group) {
            (group.selling_plans || []).forEach(function(plan) {
              var adj = (plan.price_adjustments || [])[0];
              if (adj && adj.value_type === 'percentage' && adj.value > discountPct) {
                discountPct = adj.value;
              }
            });
          });
          if (!discountPct) return;

          var basePrice = product.variants[0] && product.variants[0].price;
          if (!basePrice) return;

          var subPriceCents = Math.round(basePrice * (1 - discountPct / 100));
          var subPricePLN = (subPriceCents / 100).toFixed(2).replace('.', ',');
          var labelText = 'od ' + subPricePLN + ' zł w subskrypcji';

          var label = item.querySelector('[data-rc-sub-price-label]');
          if (!label) {
            label = document.createElement('span');
            label.setAttribute('data-rc-sub-price-label', '1');
            priceEl.parentNode.insertBefore(label, priceEl.nextSibling);
          }
          label.textContent = labelText;
          label.style.setProperty('font-size', '10px', 'important');
          label.style.setProperty('font-weight', '400', 'important');
          label.style.setProperty('line-height', '17px', 'important');
          label.style.setProperty('color', '#667d7d', 'important');
          label.style.setProperty('font-family', 'studiofeixen, sans-serif', 'important');
          label.style.setProperty('display', 'block', 'important');
          label.style.setProperty('text-align', 'left', 'important');
          label.style.setProperty('margin-top', '8px', 'important');
          label.style.setProperty('margin-bottom', '4px', 'important');
        })
        .catch(function() {
          item._rcSubPriceDone = false;
        });
    });
  }

  var CHECKBOX_SVG = '<svg data-rc-checkbox="1" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="flex-shrink:0!important"><rect x="0.2" y="0.2" width="15.6" height="15.6" rx="3.2" fill="white" stroke="#244545" stroke-width="0.4"/></svg>';

  function injectSubButtonCheckbox(shadowRoot) {
    var btns = shadowRoot.querySelectorAll('#cart-drawer button[class*="bg-storefront-drawer-secondary"]');
    btns.forEach(function(btn) {
      if (btn.querySelector('[data-rc-checkbox]')) return;
      btn.style.setProperty('justify-content', 'flex-start', 'important');
      btn.style.setProperty('gap', '9px', 'important');
      btn.style.setProperty('text-align', 'left', 'important');
      btn.childNodes.forEach(function(node) {
        if (node.nodeType === 3) {
          node.textContent = node.textContent.replace(/(\d+[.,]\d+)%/, function(_, n) {
            return Math.round(parseFloat(n.replace(',', '.'))) + '%';
          });
        }
      });
      var tmp = document.createElement('div');
      tmp.innerHTML = CHECKBOX_SVG;
      btn.insertBefore(tmp.firstChild, btn.firstChild);
    });
  }

  function styleSellingPlanSelect(shadowRoot) {
    var selects = shadowRoot.querySelectorAll('select[name="selling_plan"]');
    selects.forEach(function(select) {
      if (select._rcSelectStyled) return;
      select._rcSelectStyled = true;

      var firstSubValue = null;
      Array.from(select.options).forEach(function(opt) {
        if (opt.value && opt.value !== 'ONETIME') {
          if (!firstSubValue) firstSubValue = opt.value;
          if (opt.text.indexOf('Subskrypcja') === -1) {
            var t = opt.text.trim();
            opt.text = 'Subskrypcja - ' + t.charAt(0).toLowerCase() + t.slice(1);
          }
        }
      });

      var inCartItem = !!select.closest('[role="listitem"]');
      if (firstSubValue && !inCartItem && select.value === 'ONETIME') {
        select.value = firstSubValue;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function styleCartOverlayDrawer() {
    var overlayHost = document.querySelector('#recharge-storefront-experiences__cart-overlay');
    if (!overlayHost || !overlayHost.shadowRoot) return;
    var overlaySR = overlayHost.shadowRoot;
    if (!overlaySR.getElementById('rc-overlay-drawer-styles')) {
      var rcSty = document.createElement('style');
      rcSty.id = 'rc-overlay-drawer-styles';
      rcSty.textContent = [
        ':host {',
        '  letter-spacing: 0.06rem;',
        '  font-weight: 600;',
        '}',
        'div[data-state="open"]:has(> [role="dialog"]) {',
        '  z-index: 2147483647 !important;',
        '}',
        '#cart-overlay-drawer dl p,',
        '#cart-overlay-drawer p.text-storefront-drawer-muted {',
        '  font-size: 12px !important;',
        '  font-weight: 400 !important;',
        '  line-height: 17px !important;',
        '  color: #667d7d !important;',
        '  font-family: studiofeixen, sans-serif !important;',
        '}',
        '#cart-overlay-drawer p.font-semibold {',
        '  font-size: 14px !important;',
        '  font-weight: 500 !important;',
        '  line-height: 19px !important;',
        '  color: #244545 !important;',
        '  font-family: studiofeixen, sans-serif !important;',
        '}',
        '#cart-overlay-drawer span[part="money"] {',
        '  color: #667d7d !important;',
        '  font-size: 12px !important;',
        '  font-weight: 400 !important;',
        '  font-family: studiofeixen, sans-serif !important;',
        '}',
        '#cart-overlay-drawer span[part~="discount"] {',
        '  color: #244545 !important;',
        '  font-size: 12px !important;',
        '  font-weight: 600 !important;',
        '  font-family: studiofeixen, sans-serif !important;',
        '}',
        '#cart-overlay-drawer .flex.items-center.rounded-storefront-drawer {',
        '  background: #fff !important;',
        '  border: 1px solid #E9ECEC !important;',
        '  border-radius: 4px !important;',
        '  width: 89px !important;',
        '  height: 34px !important;',
        '  gap: 10px !important;',
        '  padding: 0 8px !important;',
        '}',
        '#cart-overlay-drawer .flex.items-center.rounded-storefront-drawer button[data-slot="button"] {',
        '  width: 20px !important;',
        '  height: 20px !important;',
        '  min-width: 20px !important;',
        '  padding: 0 !important;',
        '}',
        '#cart-overlay-drawer .flex.items-center.rounded-storefront-drawer button[data-slot="button"] svg {',
        '  width: 20px !important;',
        '  height: 20px !important;',
        '}',
        '#cart-overlay-drawer .flex.items-center.rounded-storefront-drawer input[name="quantity"] {',
        '  flex: 1 !important;',
        '  width: auto !important;',
        '  min-width: 0 !important;',
        '  height: auto !important;',
        '  font-family: studiofeixen, sans-serif !important;',
        '  font-size: 12px !important;',
        '  color: #244545 !important;',
        '  letter-spacing: 0.05em !important;',
        '  text-align: center !important;',
        '}',
        '#cart-overlay-drawer {',
        '  background-color: #FAF8F2 !important;',
        '}',
        '#cart-overlay-drawer h1 {',
        '  font-size: 20px !important;',
        '  font-family: studiofeixen, sans-serif !important;',
        '  color: #244545 !important;',
        '  padding-right: 24px !important;',
        '}',
        '#cart-overlay-drawer .dynamic-richtext p {',
        '  font-size: 14px !important;',
        '  font-weight: 500 !important;',
        '  font-family: studiofeixen, sans-serif !important;',
        '  color: #244545 !important;',
        '}',
        '#cart-overlay-drawer li {',
        '  font-size: 14px !important;',
        '  font-weight: 500 !important;',
        '  font-family: studiofeixen, sans-serif !important;',
        '  color: #244545 !important;',
        '}',
        '#cart-overlay-drawer fieldset button.bg-storefront-drawer-secondary {',
        '  border: 1px solid #244545 !important;',
        '  height: auto !important;',
        '  text-wrap: auto !important;',
        '}',
        '#cart-overlay-drawer fieldset button.bg-storefront-drawer-primary {',
        '  text-transform: uppercase !important;',
        '}',
        '#cart-overlay-drawer span[part="money"].line-through {',
        '  margin-right: 0 !important;',
        '}',
        '#cart-overlay-drawer dl {',
        '  display: none !important;',
        '}',
        '#cart-overlay-drawer .dynamic-richtext {',
        '  margin-left: 12px !important;',
        '  margin-top: 12px !important;',
        '  border-radius: 4px !important;',
        '}',
        '@media (max-width: 499px) {',
        '  #cart-overlay-drawer fieldset button {',
        '    font-size: 12px !important;',
        '  }',
        '}',
        '@media (max-width: 464px) {',
        '  #cart-overlay-drawer button.absolute.right-2.top-2 {',
        '    top: 108px !important;',
        '  }',
        '}',
        '@media (min-width: 465px) {',
        '  #cart-overlay-drawer button.absolute.right-2.top-2 {',
        '    top: 88px !important;',
        '  }',
        '}'
      ].join('\n');
      overlaySR.appendChild(rcSty);
    }
    var overlay = overlaySR.querySelector('#cart-overlay-drawer');
    if (!overlay) return;

    overlay.querySelectorAll('[data-rc-price-row]').forEach(function(row) {
      if (window.innerWidth < 500) {
        row.style.setProperty('flex-direction', 'column', 'important');
        row.style.setProperty('align-items', 'flex-end', 'important');
        row.style.setProperty('gap', '0', 'important');
      } else {
        row.style.setProperty('flex-direction', 'row', 'important');
        row.style.setProperty('align-items', 'center', 'important');
        row.style.setProperty('gap', '7px', 'important');
      }
    });

    overlay.querySelectorAll('li').forEach(function(el) {
      el.childNodes.forEach(function(node) {
        if (node.nodeType === 3) {
          node.textContent = node.textContent.replace(/(\d+[.,]\d+)%/, function(_, n) {
            return Math.round(parseFloat(n.replace(',', '.'))) + '%';
          });
        }
      });
    });

    var productSection = overlay.querySelector('.flex.items-center:not(.rounded-storefront-drawer)');
    if (!productSection || productSection._rcOverlayStyled) return;

    var nameEl = productSection.querySelector('p.font-semibold');
    if (!nameEl) return;

    var infoCol = nameEl.parentElement;
    var dl = infoCol.querySelector('dl');
    var priceArea = productSection.querySelector('.text-right.whitespace-nowrap');
    if (!priceArea) return;

    productSection._rcOverlayStyled = true;

    var savingsEl = priceArea.querySelector('.text-xs');
    if (savingsEl && savingsEl.textContent.trim()) {
      savingsEl.textContent = savingsEl.textContent.replace(/(\d+[.,]\d+)%/, function(_, n) {
        return Math.round(parseFloat(n.replace(',', '.'))) + '%';
      });
      savingsEl.setAttribute('data-rc-savings', '1');
      savingsEl.style.setProperty('display', 'block', 'important');
      savingsEl.style.setProperty('width', 'fit-content', 'important');
      savingsEl.style.setProperty('align-self', 'flex-start', 'important');
      savingsEl.style.setProperty('background-color', '#F7F4E9', 'important');
      savingsEl.style.setProperty('padding', '2px 4px', 'important');
      savingsEl.style.setProperty('border-radius', '2px', 'important');
      savingsEl.style.setProperty('color', '#667D7D', 'important');
      savingsEl.style.setProperty('font-size', window.innerWidth < 500 ? '10px' : '12px', 'important');
      savingsEl.style.setProperty('font-weight', '400', 'important');
      savingsEl.style.setProperty('line-height', '16px', 'important');
      savingsEl.style.setProperty('text-align', 'left', 'important');
      savingsEl.style.setProperty('font-family', 'studiofeixen, sans-serif', 'important');
      savingsEl.style.setProperty('margin-top', '4px', 'important');
      var anchor = dl || nameEl;
      infoCol.insertBefore(savingsEl, anchor.nextElementSibling);
    }

    var moneySpans = Array.from(priceArea.querySelectorAll('span[part*="money"]'));
    if (moneySpans.length) {
      var priceRow = priceArea.querySelector('[data-rc-price-row]');
      if (!priceRow) {
        priceRow = document.createElement('div');
        priceRow.setAttribute('data-rc-price-row', '1');
        priceArea.insertBefore(priceRow, priceArea.firstChild);
      }
      moneySpans.forEach(function(s) { priceRow.appendChild(s); });
      priceRow.style.setProperty('display', 'flex', 'important');
      priceRow.style.setProperty('flex-direction', window.innerWidth < 500 ? 'column' : 'row', 'important');
      priceRow.style.setProperty('align-items', window.innerWidth < 500 ? 'flex-end' : 'center', 'important');
      priceRow.style.setProperty('gap', '7px', 'important');
      priceRow.style.setProperty('justify-content', 'flex-end', 'important');
    }

    overlay.querySelectorAll('h1, h2, button').forEach(function(el) {
      el.childNodes.forEach(function(node) {
        if (node.nodeType === 3) {
          node.textContent = node.textContent.replace(/(\d+[.,]\d+)%/, function(_, n) {
            return Math.round(parseFloat(n.replace(',', '.'))) + '%';
          });
        }
      });
    });

    var quantityControl = overlay.querySelector('.flex.items-center.rounded-storefront-drawer');
    var selectSection = overlay.querySelector('.flex.flex-col.space-y-1');
    if (quantityControl && selectSection) {
      var labelEl = selectSection.querySelector('label');
      if (labelEl) labelEl.style.setProperty('display', 'none', 'important');
      var quantityParentRow = quantityControl.parentElement;
      var selectWrapper = selectSection.querySelector('.relative');
      if (selectWrapper) {
        var rowWrapper = document.createElement('div');
        rowWrapper.setAttribute('data-rc-qty-select-row', '1');
        rowWrapper.style.cssText = 'display:flex !important; flex-direction:row !important; align-items:center !important; gap:8px !important; width:100% !important;';
        selectSection.parentNode.insertBefore(rowWrapper, selectSection);
        rowWrapper.appendChild(quantityControl);
        quantityControl.style.cssText = 'display:flex !important; flex-direction:row !important; align-items:center !important; width:89px !important; min-width:89px !important; height:34px !important; flex-shrink:0 !important; background:#fff !important; border:1px solid #E9ECEC !important; border-radius:4px !important; gap:10px !important; padding:0 8px !important; overflow:hidden !important; box-sizing:border-box !important;';
        var qBtns = quantityControl.querySelectorAll('button[data-slot="button"]');
        var svgMinus = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M5.2251 10H14.7751" stroke="#244545" stroke-width="1.5" stroke-miterlimit="10"/></svg>';
        var svgPlus = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M5.2251 10H14.7751" stroke="#244545" stroke-width="1.5" stroke-miterlimit="10"/><path d="M10 5.2251V14.7751" stroke="#244545" stroke-width="1.5" stroke-miterlimit="10"/></svg>';
        qBtns.forEach(function(btn, idx) {
          btn.style.cssText = 'width:20px !important; height:20px !important; min-width:20px !important; min-height:20px !important; max-width:20px !important; max-height:20px !important; padding:0 !important; flex-shrink:0 !important; display:flex !important; align-items:center !important; justify-content:center !important; background:transparent !important; border:none !important;';
          btn.innerHTML = idx === 0 ? svgMinus : svgPlus;
        });
        var qInput = quantityControl.querySelector('input[name="quantity"]');
        if (qInput) qInput.style.cssText = 'flex:1 !important; width:auto !important; min-width:0 !important; height:auto !important; font-family:studiofeixen,sans-serif !important; font-size:12px !important; font-weight:400 !important; color:#244545 !important; letter-spacing:0.05em !important; text-align:center !important; background:transparent !important; border:none !important; outline:none !important; padding:0 !important;';
        selectWrapper.style.setProperty('flex', '1', 'important');
        rowWrapper.appendChild(selectWrapper);
        if (quantityParentRow) quantityParentRow.style.setProperty('display', 'none', 'important');
        selectSection.style.setProperty('display', 'none', 'important');
      }
    }

    var cardSection = productSection.parentElement;
    if (cardSection && !cardSection._rcCardStyled) {
      cardSection._rcCardStyled = true;
      cardSection.style.setProperty('background', '#fff', 'important');
      cardSection.style.setProperty('border-radius', '4px', 'important');
      cardSection.style.setProperty('margin', '12px 24px', 'important');
      cardSection.style.setProperty('padding', '8px', 'important');
      cardSection.style.setProperty('gap', '11px', 'important');
      cardSection.style.setProperty('border-top', 'none', 'important');
    }
  }

  function styleCarouselAddDialog(shadowRoot) {
    shadowRoot.querySelectorAll('.flex.flex-col.text-sm.gap-1 span[part="money"]').forEach(function(el) {
      el.style.setProperty('text-align', 'left', 'important');
    });
  }

  function applyToShadowRoot(shadowRoot) {
    injectStyles(shadowRoot);
    transformCartCountBadge(shadowRoot);
    replaceQuantityIcons(shadowRoot);
    styleListItems(shadowRoot);
    styleFooter(shadowRoot);
    fixCarouselAlignment(shadowRoot);
    styleQuantityRow(shadowRoot);
    styleCartItemDetails(shadowRoot);
    updateCarouselSubPriceLabel(shadowRoot);
    injectSubButtonCheckbox(shadowRoot);
    styleSellingPlanSelect(shadowRoot);
    styleCarouselAddDialog(shadowRoot);
  }

  function attachTrashHandler(shadowRoot) {
    shadowRoot.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-rc-trash]');
      if (!btn) return;

      var listItem = btn.closest('[role="listitem"]');
      if (!listItem) return;

      var allItems = shadowRoot.querySelectorAll('#cart-drawer [role="listitem"]');
      var idx = Array.prototype.indexOf.call(allItems, listItem);
      if (idx === -1) return;

      e.stopImmediatePropagation();
      e.stopPropagation();

      btn.style.setProperty('opacity', '0.4', 'important');
      btn.style.setProperty('pointer-events', 'none', 'important');

      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var item = cart.items[idx];
          if (!item) throw new Error('not found');
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: item.key, quantity: 0 })
          }).then(function(r) { return r.json(); });
        })
        .then(function(updatedCart) {
          listItem.style.setProperty('display', 'none', 'important');
          var badge = shadowRoot.querySelector('.rc-cart-count-badge');
          if (badge) {
            var n = parseInt(badge.textContent, 10);
            if (!isNaN(n)) badge.textContent = Math.max(0, n - 1);
          }
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: updatedCart }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        })
        .catch(function() {
          btn.style.removeProperty('opacity');
          btn.style.removeProperty('pointer-events');
        });
    }, true);
  }

  function initShadowRoot(shadowRoot) {
    if (shadowRoot._rcCartDrawerInit) return;
    shadowRoot._rcCartDrawerInit = true;
    applyToShadowRoot(shadowRoot);
    attachTrashHandler(shadowRoot);
    new MutationObserver(function () {
      applyToShadowRoot(shadowRoot);
    }).observe(shadowRoot, { childList: true, subtree: true });
    window.addEventListener('resize', function() {
      applyToShadowRoot(shadowRoot);
    });
  }

  // Host szuflady ReCharge ma stałe id — wcześniej każda zmiana DOM przeglądała
  // wszystkie elementy strony (querySelectorAll('*')), co mocno psuło INP.
  function findCartDrawerShadowRoot() {
    var host = document.getElementById('recharge-storefront-experiences__cart-drawer');
    var sr = host && host.shadowRoot;
    if (!sr) return false;
    initShadowRoot(sr);
    return true;
  }

  function initOverlayShadowRoot() {
    var overlayHost = document.getElementById('recharge-storefront-experiences__cart-overlay');
    if (!overlayHost || !overlayHost.shadowRoot) return false;
    if (overlayHost.shadowRoot._rcOverlayInit) return true;
    overlayHost.shadowRoot._rcOverlayInit = true;
    styleCartOverlayDrawer();
    new MutationObserver(function() {
      styleCartOverlayDrawer();
    }).observe(overlayHost.shadowRoot, { childList: true, subtree: true, attributes: true });
    window.addEventListener('resize', styleCartOverlayDrawer);
    return true;
  }

  // Szukamy hostów tylko do momentu, aż oba się pojawią — potem obserwator się odpina.
  function initHosts() {
    var drawer = findCartDrawerShadowRoot();
    var overlay = initOverlayShadowRoot();
    return drawer && overlay;
  }

  if (!initHosts()) {
    var hostsObserver = new MutationObserver(function () {
      if (initHosts()) hostsObserver.disconnect();
    });
    hostsObserver.observe(document.body, { childList: true, subtree: true });
  }
})();
